import {
    AppBar,
    Avatar,
    Hidden,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    MenuItem,
    Toolbar,
} from '@material-ui/core';
import { ExitToApp } from '@material-ui/icons';
import React from 'react';
import { useAppContext } from './Context';
import { getUserProfile, doLogout } from '../keycloak';

const AppToolbar = ({ logo }) => {
    const { pontoTroca, updateAppContext } = useAppContext();
    const setPontoTroca = () => updateAppContext({ pontoTroca: undefined });
    const user = getUserProfile();
    return (
        <AppBar position="sticky">
            <Toolbar>
                <img src={logo} alt="logo" height="32px" />
                <div
                    style={{
                        display: 'flex',
                        flexGrow: 1,
                        justifyContent: 'center',
                    }}
                >
                    {pontoTroca && (
                        <MenuItem onClick={setPontoTroca}>
                            <ListItemText
                                primary={pontoTroca.empresaNome}
                                secondary={pontoTroca.endereco}
                                style={{ maxWidth: '50vw' }}
                            />
                        </MenuItem>
                    )}
                </div>
                <List>
                    <ListItem>
                        <Hidden smDown>
                            <ListItemAvatar>
                                <Avatar />
                            </ListItemAvatar>
                        </Hidden>
                        <ListItemText
                            primary={
                                user && (user.name || user.preferred_username)
                            }
                            secondary={user && user.email}
                        />
                        <ListItemSecondaryAction>
                            <IconButton
                                color="inherit"
                                onClick={doLogout}
                                title="Sair"
                            >
                                <ExitToApp />
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                </List>
            </Toolbar>
        </AppBar>
    );
};

export default AppToolbar;
